var CompanionConfig = function CompanionConfig() {
  var _props$companionUrl;

  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if (!(props !== null && props !== void 0 && (_props$companionUrl = props.companionUrl) !== null && _props$companionUrl !== void 0 && _props$companionUrl.length)) {
    throw new Error('Missing required prop companionUrl');
  }

  return {
    companionUrl: props.companionUrl,
    companionHeaders: {
      'Access-Control-Allow-Origin': '*'
    },
    headers: {
      'Access-Control-Allow-Origin': '*'
    }
  };
};

export default CompanionConfig;